import React, { useState, useEffect, useMemo, useRef } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import axios from "../../axios-instance";
import ReactTable from "react-table";
import withFixedColumns from "react-table-hoc-fixed-columns";
import ClipboardJS from "clipboard";

import Container from "../../components/UI/Container/Container";
import {
  approveTransaction,
  deleteTransaction,
  editTransaction,
  getTransactions,
  clearTransactions,
  deleteSeatsTransaction,
} from "../../store/actions/TransactionsActions";
import NewLoader from "../../components/NewLoader/NewLoader";
import PageTitle from "../../components/UI/PageTitle/PageTitle";
import { paymentStatuses } from "../../constants/paymentStatuses";
import { PaymentStatusLabel } from "../../components/Transactions/PaymentStatusLabel/PaymentStatusLabel";
import ROUTES from "../../constants/routes";
import { getEvent, getEventSellStats } from "../../store/actions/eventsActions";
import { EditTransactionModal } from "./Modals/EditTransactionModal";
import { getHeaders } from "../../helpers/getHeaders";
import { useLazyLoadOnTableScroll } from "../../hooks/useLazyLoadOnTableScroll";
import { SeatsDescription } from "../../components/Transactions/SeatsDescription/SeatsDescription";
import { TransactionActions } from "../../components/Transactions/TransactionActions/TransactionActions";
import { RefundTicketsModal } from "./Modals/RefundTicketsModal";

import "react-table-hoc-fixed-columns/lib/styles.css";
import "react-table/react-table.css";
import "./Transactions.sass";
import { Breadcrumbs } from "../../components/Breadcrumbs/Breadcrumbs";

const MySwal = withReactContent(Swal);

export const Transactions = ({
  transactions,
  getTransactions,
  approveTransaction,
  deleteTransaction,
  editTransaction,
  clearTransactions,
  deleteSeatsTransaction,
  currentEvent,
  getEventSellStats,
  getEvent,
  match: { params },
}) => {
  const [user, setUser] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [searchPaymentStatus, setSearchPaymentStatus] = useState(null);

  const contextMenuRef = useRef(null);

  const pageSize = 50;
  let selectedTransaction;
  const event_id = params.event_id || params.id;
  const { transactionsList, transactionsTotal, firstTransactionsLoading } =
    transactions;

  const ReactTableFixedColumns = useMemo(
    () => withFixedColumns(ReactTable),
    []
  );

  const [page, handleTransactionsTableScroll, resetPage] =
    useLazyLoadOnTableScroll(pageSize, transactionsTotal);

  const changeSearchInputHandler = (e) => {
    resetPage();
    clearTransactions();
    setSearchQuery(e.target.value);
  };

  const changeSearchPaymentStatusHandler = (item) => {
    resetPage();
    clearTransactions();
    setSearchPaymentStatus(item);
  };

  const loadUser = () => {
    const currentUser = JSON.parse(localStorage.getItem("user"));
    setUser(currentUser);
  };

  const getEventTransactions = (userToken) =>
    getTransactions(
      userToken,
      searchQuery,
      searchPaymentStatus == null ? [] : [searchPaymentStatus.value],
      event_id,
      "",
      page,
      pageSize
    );

  const showApproveTransactionModal = (transaction) => {
    MySwal.fire({
      title: "Are you sure you want to approve this transaction?",
      text: "It’s impossible to take step back then",
      confirmButtonText: "Approve",
      cancelButtonText: "Cancel",
      showCancelButton: true,
      reverseButtons: true,
      input: "checkbox",
      inputValue: 1,
      inputPlaceholder: "Create and send a fiscal receipt",
      customClass: "approve-user-modal",
    }).then(({ value }) => {
      if (value === 0 || value === 1) {
        approveTransaction(
          user.token,
          transaction.id,
          value === 1 ? true : false
        );
      }
    });
  };

  const showDeleteTransactionModal = (transaction) => {
    MySwal.fire({
      title: "Are you sure you want to delete this transaction?",
      text: "It’s impossible to take step back then",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      showCancelButton: true,
      reverseButtons: true,
      customClass: "delete-user-modal",
    }).then(({ value }) => {
      if (value) {
        deleteTransaction(user.token, transaction.id);
      }
    });
  };

  const showEditTransactionModal = (transaction) => {
    MySwal.fire({
      title: "Edit Information",
      html: (
        <EditTransactionModal
          token={user.token}
          editTransaction={editTransaction}
          deleteSeatsTransaction={deleteSeatsTransaction}
          transaction={transaction}
        />
      ),
      showConfirmButton: false,
      customClass: "edit-user-modal",
    });
  };

  const showRefundTicketsModal = (transaction) => {
    MySwal.fire({
      title: "Refund tickets",
      html: <RefundTicketsModal token={user.token} transaction={transaction} />,
      showConfirmButton: false,
      customClass: "refund-tickets-modal",
    });
  };

  const resendTicketsHandler = (e) => {
    axios
      .post(
        `/ManageTransactions/ResendTicket/${selectedTransaction.id}`,
        null,
        {
          headers: getHeaders(user.token),
        }
      )
      .then((response) => {
        if (response.status === 200) {
          if (response.data) {
            toast.success("Tickets successfully resent");
          } else {
            toast.error("Tickets not sent");
          }
          return;
        }

        throw new Error(response.data.errorMessage);
      })
      .catch((err) => {
        toast.error("Tickets not sent");
      });
  };

  const resendInvoiceHandler = (e) => {
    console.log(selectedTransaction);
    axios
      .post(
        `/ManageTransactions/ResendInvoice/${selectedTransaction.id}?emailTemplateName=${selectedTransaction.ticketTemplate}`,
        null,
        {
          headers: getHeaders(user.token),
        }
      )
      .then((response) => {
        if (response.status === 200) {
          toast.success("Invoice successfully resent");
          return;
        }

        throw new Error(response.data.errorMessage);
      })
      .catch((err) => {
        toast.error("Invoice not sent");
      });
  };

  const showLinkCopied = (link) => {
    ClipboardJS.copy(link);

    toast.dismiss(257);
    toast.success("Link was copied to clipboard.", {
      toastId: 257,
    });
  };

  const copyOfferLinkHandler = (e) => {
    showLinkCopied(
      `${process.env.REACT_APP_PUBLIC_URL}/offers/${selectedTransaction.id}`
    );
  };

  const copyTicketLinkHandler = (e) => {
    showLinkCopied(
      `${process.env.REACT_APP_PUBLIC_URL}/v1/Transaction/Ticket/${selectedTransaction.ticketResultGuid}`
    );
  };

  useEffect(() => {
    if (user.token) {
      getEventTransactions(user.token);
    }
  }, [user, page, searchQuery, searchPaymentStatus]);

  useEffect(() => {
    if (user.token) {
      if (!currentEvent.id) {
        getEvent(event_id, user.token).then((res) => {
          if (res.isFound) {
            getEventSellStats(event_id, user.token);
          }
        });
      }
    }
  }, [user]);

  useEffect(() => {
    clearTransactions();
    loadUser();
  }, []);

  const getLabelStyle = (state, rowInfo, column) => ({
    style: {
      marginTop: "6px",
    },
  });

  const setSelectedTransaction = (transaction) => {
    selectedTransaction = transaction;
  };

  const columns = [
    {
      Header: "Name",
      accessor: "fullName",
      resizable: false,
      width: 180,
      getProps: getLabelStyle,
    },
    {
      Header: "Email",
      accessor: "buyerEmail",
      resizable: false,
      width: 280,
      getProps: getLabelStyle,
    },
    {
      Header: "Seats",
      accessor: "seatsDescription",
      resizable: false,
      width: 300,
      getProps: getLabelStyle,
      Cell: ({ row: { _original: transaction } }) => (
        <SeatsDescription seats={transaction.seats} />
      ),
    },
    {
      Header: "Payment status",
      accessor: "paymentStatus",
      resizable: false,
      width: 135,
      getProps: getLabelStyle,
      Cell: ({
        row: {
          paymentStatus,
          _original: { transactionErrorCode, transactionErrorMessage },
        },
      }) => {
        const description =
          paymentStatus === 2
            ? transactionErrorMessage
              ? `${transactionErrorCode}: ${transactionErrorMessage}`
              : ""
            : "";

        return (
          <PaymentStatusLabel
            paymentStatusValue={paymentStatus}
            description={description}
          />
        );
      },
    },
    {
      Header: "Transaction ID",
      accessor: "id",
      resizable: false,
      width: 320,
      getProps: getLabelStyle,
    },
    {
      Header: "Payment ID",
      accessor: "transactionId",
      resizable: false,
      width: 160,
      getProps: getLabelStyle,
    },
    {
      Header: "",
      Cell: ({ row: { _original: transaction } }) => (
        <TransactionActions
          contextMenuRef={contextMenuRef}
          transaction={transaction}
          setSelectedTransaction={setSelectedTransaction}
          showDeleteTransactionModal={showDeleteTransactionModal}
          showApproveTransactionModal={showApproveTransactionModal}
          showEditTransactionModal={showEditTransactionModal}
          showRefundTicketsModal={showRefundTicketsModal}
          resendTicketsHandler={resendTicketsHandler}
          resendInvoiceHandler={resendInvoiceHandler}
          copyOfferLinkHandler={copyOfferLinkHandler}
          copyTicketLinkHandler={copyTicketLinkHandler}
        />
      ),
      width: 280,
      fixed: "right",
    },
  ];

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      height: "46px",
      "min-height": "46px",
      cursor: "pointer",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#ABABAB",
    }),
  };

  let emptyStateText = "There are no transactions";

  if (transactionsTotal === 0 && searchQuery) {
    emptyStateText = "Sorry, no results were found";
  }

  const fullPath = [
    {
      path: ROUTES.EVENTS,
      name: "Events",
    },
    {
      path: ROUTES.EVENT.replace(":id", event_id),
      name: currentEvent.name,
    },
    {
      name: "Transactions",
    },
  ];

  return (
    <Container className="transactions">
      <PageTitle>
        <Breadcrumbs routes={fullPath} />
      </PageTitle>

      <div className="searchPanel">
        <Select
          isClearable
          options={paymentStatuses}
          placeholder="Select payment status"
          name="searchPaymentStatus"
          classNamePrefix="seasonpass__select"
          value={searchPaymentStatus}
          onChange={changeSearchPaymentStatusHandler}
          className="seasonpass__select searchPanel__select"
          styles={customSelectStyles}
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary: "#6071B5",
              primary25: "#F2F4FE",
              primary50: "#F2F4FE",
              primary75: "#F2F4FE",
            },
          })}
        />

        <input
          className="searchPanel__search input-behavior"
          type="text"
          placeholder="Search"
          value={searchQuery}
          onChange={changeSearchInputHandler}
        />
      </div>

      {firstTransactionsLoading ? (
        <NewLoader />
      ) : transactionsList.length ? (
        <>
          <ReactTableFixedColumns
            data={transactionsList}
            columns={columns}
            manual
            showPagination={false}
            minRows={0}
            sortable={false}
            getTrProps={() => ({
              style: {
                alignItems: "stretch",
              },
            })}
            getTableProps={() => ({
              onScroll: handleTransactionsTableScroll,
            })}
          />
        </>
      ) : (
        <div className="events__empty-state">
          <PageTitle>{emptyStateText}</PageTitle>
          <img src="/images/img-empty-events.svg" alt="Empty transactions" />
        </div>
      )}
    </Container>
  );
};

const mapStateToProps = ({ auth, transactions, events }) => ({
  auth,
  token: auth.user.token,
  transactions,
  currentEvent: events.currentEvent,
});

const mapDispatchToProps = (dispatch) => ({
  getTransactions: (
    userToken,
    searchQuery,
    paymentStatuses,
    eventId,
    transactionStatus,
    page,
    pageSize
  ) =>
    dispatch(
      getTransactions(
        userToken,
        searchQuery,
        paymentStatuses,
        eventId,
        transactionStatus,
        page,
        pageSize
      )
    ),
  approveTransaction: (userToken, id, makeFiscalization) =>
    dispatch(approveTransaction(userToken, id, makeFiscalization)),
  deleteTransaction: (userToken, id) =>
    dispatch(deleteTransaction(userToken, id)),
  editTransaction: (userToken, transaction) =>
    dispatch(editTransaction(userToken, transaction)),
  clearTransactions: () => dispatch(clearTransactions()),
  deleteSeatsTransaction: (userToken, transaction, seatIds) =>
    dispatch(deleteSeatsTransaction(userToken, transaction, seatIds)),
  getEvent: (eventId, token) => dispatch(getEvent(eventId, token)),
  getEventSellStats: (eventId, token) =>
    dispatch(getEventSellStats(eventId, token)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Transactions)
);
